















































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import {
  pagination,
  loadingCatch,
  loading,
  SearchbarControl,
  IsMore
} from "@root/lib/decorator";

const common = namespace("common");
const wt = namespace("wt");
@Component
@pagination("getData", {
  pageSize: 50
})
@SearchbarControl()
@loading()
@IsMore(true)
export default class WtActivity extends Vue {
  @common.Action queryDataDictionaryListLang;
  @common.State wtBrandTags;

  @wt.Action queryPriceActivity;
  @wt.Action changeActivityStatus;
  // private isPCR = false; // activity_type(1  PCR  2 TBR)

  private dataList = [];
  private dicOptions = [{ value: "", label: "全部" }];

  private tabLoading = false;
  private loading = false;

  private form = {
    status: "",
    acName: "",
    pdName: "",
    acStartDate: [],
    acEndDate: [],
    createDate: [],
    acTime: "",
    startDate: "",
    endDate: "",
    acCode: "",
    creater: ""
  };
  // TODO：状态数字，统一为变量

  get dataListComputed() {
    return this.dataList;
  }
  get routeType() {
    const { path } = this.$route;
    const type = ~String(path)
      .toLowerCase()
      .indexOf("pcr")
      ? "pcr"
      : "tbr";
    return String(type).toLowerCase();
  }

  get pageTitle() {
    const prefixStr = String(this.routeType).toUpperCase();
    // return `${prefixStr}活动价`;
    return "发布活动";
  }

  @Watch("$route")
  handleRouteChange() {
    (this as any).onResetBtnClick();
    this.tabToggleHandle("");
  }

  isOaCooperation: any = '';
  createAc() {
    // 创建
    this.goEditPage(0, "");

  }
  reviewAc(row) {
    // 查看
    this.goEditPage(1, row.activityCode);
  }
  editAC(row) {
    // 编辑
    this.goEditPage(2, row.activityCode);
  }
  cloneAc(row) {
    // 复制
    this.goEditPage(3, row.activityCode);
  }

  goEditPage(pageStatus, activityCode) {
    // 创建没有isPageEdit
    this.$router.push({
      // name: "WtActivityEditType",
      path: `/wtActivity/${this.routeType}/wtActivityEdit`,
      query: { pageStatus: String(pageStatus), code: activityCode }, // 创建，查看，编辑，复制 0,1,2,3 <string>
      params: { type: this.routeType }
    });
  }

  async stopAc(row) {
    // 终止，生效中/已结束 终止都转为已完成（04）
    await this.$confirm("你确定终止活动吗？", "", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    });
    await this.changeStatus(row.activityCode, "04");
    await this.getData();
  }
  async publishAc(row) {
    // 发布
    await this.$confirm("你确定发布活动吗？", "", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    });
    await this.changeStatus(row.activityCode, "02");
    await this.getData();
  }

  async changeStatus(code, status) {
    try {
      await this.changeActivityStatus({
        activityCode: code,
        status
      });
    } catch (error) {
      console.error(error);
    }
  }

  async created() {
    this.isOaCooperation = localStorage.getItem("isOaCooperation");
    await this.init();
  }

  async init() {
    this.loading = true;
    await this.getDics();
    await this.getData();
    this.loading = false;
  }

  async getDics() {
    this.tabLoading = true;
    try {
      const dicData = await this.queryDataDictionaryListLang({
        statePath: "wtActivityList",
        ddCode: "ACTIVITY_STATUS"
      });
      this.dicOptions = dicData.map(({ value, ...el }) => ({
        value: String(parseInt(value) || ""),
        ...el
      }));
    } finally {
      this.tabLoading = false;
    }
  }

  @loadingCatch
  async getData() {
    const { pageSize, currentPage: pageNum } = this as any;
    const pageInput = {
      pageSize,
      pageNum
    };

    const timeArr = (time, index) => {
      if (!time || time.length === 0) return;
      return time && time.length > 0 ? time[index] : "";
    };

    try {
      const {
        acName,
        pdName,
        status,
        createDate,
        acStartDate,
        acEndDate
      } = this.form;
      let dateItem = {};
      if (createDate && createDate.length > 0) {
        dateItem["startDate"] = timeArr(createDate, 0);
        dateItem["endDate"] = timeArr(createDate, 1);
      }
      if (acStartDate && acStartDate.length > 0) {
        dateItem["activityBeginStart"] = timeArr(acStartDate, 0);
        dateItem["activityBeginStop"] = timeArr(acStartDate, 1);
      }
      if (acEndDate && acEndDate.length > 0) {
        dateItem["activityEndStart"] = timeArr(acEndDate, 0);
        dateItem["activityEndStop"] = timeArr(acEndDate, 1);
      }
      const formInput = {
        // 列表过滤内容
        activityName: this.form.acName,
        activityCode: this.form.acCode,
        activityStatus: parseInt(status) < 10 ? "0" + status : "",
        activityType: this.routeType,
        ...dateItem
      };
      let { total, list } = await this.queryPriceActivity({
        input: formInput,
        pageInput
      });
      (this as any).total = total;
      this.dataList = list;
    } catch (err) {
      console.error(err);
      this.dataList = [];
      (this as any).total = 0;
    }
  }

  tabToggleHandle(status) {
    this.$set(this.form, "status", status);
    (this as any).onSearchBtnClick();
  }

  getActivityStatusString(status) {
    const d = this.dicOptions.find(
      ({ value }) => parseInt(status) === parseInt(value)
    );
    return (d && d.label) || "已终止"; // "已终止：异常处理"
  }
}
